// extracted by mini-css-extract-plugin
module.exports = {"image":"image"};